module.exports = __webpack_public_path__ + "img/2025-09-19c_3.fa0057ab.jpg";